import { Component, OnInit, Input } from '@angular/core';
import { ChecklistProfileSurveyService } from '../../service/checklist-profile-survey/checklist-profile-survey.service';
import { ChecklistProfileSurvey } from '../../class/checklist-profile-survey';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ProfileSurvey } from '../../class/profile-survey';
import { config } from '../../../../../environments/config';

@Component({
  selector: 'app-checklist-profile-surveis',
  templateUrl: './checklist-profile-surveis.component.html',
  styleUrls: ['./checklist-profile-surveis.component.scss']
})
export class ChecklistProfileSurveisComponent implements OnInit {

    // @Input() profileSurvey: ProfileSurvey;
    @Input() profileSurveyId: number;

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public checklistProfileSurveis: ChecklistProfileSurvey[];
    public selectChecklistProfileSurvey: ChecklistProfileSurvey;
    public checklistProfileSurveiID: Number = 0;
    public modNew = false;
    public modView = false;
    public openChecklistProfileSurvey = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public query: string;
    public first = 0;

    public filters: any[];

    public apiUrl = config.API_ROOT;


    constructor(
        public checklistProfileSurveiService: ChecklistProfileSurveyService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public fb: FormBuilder) { 
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 1000;
        this.sort = '-id';
    
        // this.filter();
    }

    public loadChecklistProfileSurveysLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-id';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }
        if (this.profileSurveyId) {
                this.filters = [];
                this.filters.push({'key': 'profile_survey_id-lk', 'value': this.profileSurveyId});
        }
                
        this.getChecklistProfileSurveys();
    }

    public getChecklistProfileSurveys() {
        this.checklistProfileSurveiService.getChecklistProfileSurvey(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.checklistProfileSurveis = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newChecklistProfileSurvey() {
        this.modNew = !this.modNew;
        this.selectChecklistProfileSurvey = null;
    }

    public savedChecklistProfileSurvey(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectChecklistProfileSurvey = null;
        this.modNew = false;
        // this.getChecklistProfileSurveys();
    }

    public cancelChecklistProfileSurvey (res) {
        this.selectChecklistProfileSurvey = null;
        this.modNew = false;
        this.modView = false;
        // this.getChecklistProfileSurveys();
    }

    public edit(checklistProfileSurvei: ChecklistProfileSurvey) {
        this.modNew = true;
        this.selectChecklistProfileSurvey = checklistProfileSurvei;
        // this.getChecklistProfileSurveys();
    }

    public view(checklistProfileSurvei: ChecklistProfileSurvey) {
        this.openChecklistProfileSurvey = true;
        this.selectChecklistProfileSurvey = checklistProfileSurvei;
        this.checklistProfileSurveiID = checklistProfileSurvei.id;
        this.modView = true;
    }

    public deleteDialog(checklistProfileSurvei: ChecklistProfileSurvey) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(checklistProfileSurvei);
            }
        });
    }

    public delete(checklistProfileSurvei: ChecklistProfileSurvey) {
        this.checklistProfileSurveiService.deleteChecklistProfileSurvey(checklistProfileSurvei.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                // this.getChecklistProfileSurveys();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeChecklistProfileSurvey(checklistProfileSurvei: ChecklistProfileSurvey) {
        this.putChecklistProfileSurvey(checklistProfileSurvei);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putChecklistProfileSurvey(values: ChecklistProfileSurvey) {
        const param = {
            'activated': values.activated,
            'required': values.required
        };
        if (values) {
            const promise = this.checklistProfileSurveiService.updateChecklistProfileSurvey(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filter (values?) {
        this.first = 0;
        this.filters = [];

        if (this.profileSurveyId) {
            if (this.profileSurveyId) {
                this.filters.push({'key': 'profile_survey_id-lk', 'value': this.profileSurveyId});
            }
        }

        this.getChecklistProfileSurveys();
    }

    public gotoAttachment(id) {
        window.open(this.apiUrl + '/list-document-profile-surveis/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/checklist-profile-surveis/checklist-profile-surveis.component.ts